import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  EditPrescriptionRequestT,
  PrescriptionT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchEditPrescription } from '../api/editPrescription.js';
import { rxKeys } from './keys.js';

export interface EditPrescriptionVariables {
  dosespotPrescriptionId: string;
  data: EditPrescriptionRequestT;
  userId?: string;
}

export function useEditPrescriptionMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rx', 'prescriptions', 'edit'],
    mutationFn: async ({
      dosespotPrescriptionId,
      data,
    }: EditPrescriptionVariables): Promise<PrescriptionT> => {
      return await fetchEditPrescription(dosespotPrescriptionId, data);
    },
    onSuccess: async (_data, variables) => {
      if (!variables.userId) {
        return;
      }

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: rxKeys.patientPrescriptions(variables.userId) }),
        queryClient.invalidateQueries({
          queryKey: rxKeys.prescription(variables.userId, variables.dosespotPrescriptionId),
        }),
      ]);
    },
  });
}
